import { useParksViewContext } from "provider/ParkViewProvider";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import path from "assets/img/locationpath.svg";
import print from "assets/img/printP.png";
import rupees from "assets/img/rupees.png";
import plan from "assets/img/planpath.svg";
import bugy from "assets/img/bugeypath.svg";
import bus from "assets/img/buspath.svg";
import lock from "assets/img/lockpath.png";
import nightMode from "assets/img/nightmodepath.png";
import rupeeFormat from "components/Api/RupeeFormat";
import { useEffect, useRef, useState } from "react";
import CorrectionModal from "./modal/CorrectionModal";
import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle.min";

const ParkMainOverView = () => {
  const tooltipRef = useRef(null);
  const suggestionBtnRef = useRef(null);

  const { parkDetail, parkViewLoading, suggCorrToggle, parksViewDispatch } = useParksViewContext();

  useEffect(() => {
    const tooltipInstance = new Tooltip(tooltipRef.current);
    return () => tooltipInstance.dispose();
  }, []);

  const handleModalClose = () => {
    parksViewDispatch({
      type: "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE",
      payload: false,
    });

    setTimeout(() => {
      const btn = suggestionBtnRef.current;
      btn?.blur(); // blur button

      // hide tooltip
      const svg = btn?.querySelector("svg");
      const tooltipInstance = Tooltip.getInstance(svg);
      tooltipInstance?.hide();
    }, 50);
  };
  return (
    <>
      <Row className="justify-content-center">
        <Col xxl={10} xl={12} lg={12}>
          <Row className="mb-2">
            <Col
              xxl={2}
              xl={2}
              lg={2}
              style={{ borderBottom: "1px solid #0000004D" }}
            >
              <div className="tiger_images w-100">
                <img
                  src={parkDetail?.feature_image_path}
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </Col>
            <Col
              xxl={9}
              xl={9}
              lg={9}
              className="pt-4"
              style={{ borderBottom: "1px solid #0000004D" }}
            >
              <div className="main_parent d-flex justify-content-between">
                <div className="title d-flex gap-4">
                  <h3>{parkDetail?.about_title}</h3>
                  {/* <div className="follow mb-lg-2 mb-xxl-0 mb-2">
                    <Link
                      className="parkrevieBtn"
                      to="/operator/ankit-kankane-safaris/follow"
                      data-pjax="0"
                    >
                      {" "}
                      Follow
                    </Link>
                  </div> */}
                </div>
                <div className="right_button float-lg-end pb-2 d-lg-block d-flex justify-content-end">
                  <Button
                    ref={suggestionBtnRef}
                    variant="link"
                    className="btn-exclamation pe-1 writeSuggestionBtn"
                    onClick={() => { parksViewDispatch({ type: "SET_PARK_VIEW_CORRECTION_SUGGESTION_TOGGLE", payload: true }); }}
                  >
                    <svg
                      ref={tooltipRef}
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="30"
                      viewBox="0 0 512 512"
                      data-bs-toggle="tooltip"
                     data-bs-custom-class="custom-tooltip"
                      data-bs-placement="top"
                      title="Submit correction if found wrong information!"
                      style={{ cursor: "pointer" }}
                    >
                      <g>
                        <path
                          d="M507.494 426.066 282.864 53.537a31.372 31.372 0 0 0-53.73 0L4.506 426.066a31.37 31.37 0 0 0 26.864 47.569h449.259a31.372 31.372 0 0 0 26.865-47.569zM256.167 167.227c12.901 0 23.817 7.278 23.817 20.178 0 39.363-4.631 95.929-4.631 135.292 0 10.255-11.247 14.554-19.186 14.554-10.584 0-19.516-4.3-19.516-14.554 0-39.363-4.63-95.929-4.63-135.292 0-12.9 10.584-20.178 24.146-20.178zm.331 243.791c-14.554 0-25.471-11.908-25.471-25.47 0-13.893 10.916-25.47 25.471-25.47 13.562 0 25.14 11.577 25.14 25.47 0 13.562-11.578 25.47-25.14 25.47z"
                          fill="#585757"
                        />
                      </g>
                    </svg>
                  </Button>
                </div>
                <div id="flashMessage" style={{ display: "none" }}>
                  Submit correction if found wrong information!
                </div>
              </div>
              <div className="detailesOrLocation">
                <Row className="">
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={path} alt="" className="iconTop mt-1" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Location</span>
                        <span className="titles_filed">
                          {`${parkDetail?.state?.state_name}, ${parkDetail?.location?.title}`}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={bus} alt="" className="iconTop mt-1"/>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Nearest Railway Station</span>
                        <span className="titles_filed">
                          {parkDetail?.railway_station_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={plan} alt="" className="iconTop mt-1"/>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Nearest Airport</span>
                        <span className="titles_filed">
                          {parkDetail?.airport?.name}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={bugy} alt="" className="iconTop mt-1"/>
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Safari Mode</span>
                        <span className="titles_filed">
                          {parkDetail?.safari_vehicles_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={nightMode} alt="" style={{ height: "18px" }} className="iconTop " />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Safari Session</span>
                        <span className="titles_filed">
                          {parkDetail?.safari_sessions_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={print} alt="" style={{ height: "15px" }} className="iconTop mt-1" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Wildlife Found</span>
                        <span className="titles_filed">
                          {`${parkDetail?.state?.state_name}, ${parkDetail?.location?.title}`}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={rupees} alt="" style={{ height: "14px" }}className="iconTop mt-1" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Safari Cost</span>
                        <span className="titles_filed">
                          {`${rupeeFormat(
                            parkDetail?.avg_safari_price_min
                          )} - ${rupeeFormat(parkDetail?.avg_safari_price_max)}`}
                          <span className="avg_price">Average Safari Price*</span>
                        </span>
                        <span className="avg_price_condition">Subject to operator discretion</span>
                      </div>
                    </div>
                  </Col>
                  <Col xl={4} md={4} sm={6} xs={12} className="mb-3">
                    <div className="items_bg d-flex gap-1">
                      <div className="top_list">
                        <img src={lock} alt="" style={{ height: "18px" }} className="iconTop" />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="mark_area">Closed Months</span>
                        <span className="titles_filed">
                          {parkDetail?.locked_months_list}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      {suggCorrToggle && <CorrectionModal handleClose={handleModalClose} />}
    </>
  );
};

export default ParkMainOverView;
